/**  Типы действий для витрины */
export enum ShowCaseActionType {

	// Закрыть вклад
	Close = 'Close',

	// Скачать файл
	DownloadFile = 'DownloadFile',

	// Октрыть ссылку в браузере
	OpenLinkInBrowser = 'OpenLinkInBrowser',

	// Октрыть ссылку в приложении
	OpenLinkInApp = 'OpenLinkInApp',

	None = ''

}
